import request from '../config/axiosConfig';
import {
  GET_LIST_POPUPS,
  GET_POPUP_DETAIL,
  CREATE_UPDATE_POPUP,
  DELETE_POPUP,
  POPUP_STATUS_CHANGE,
} from '../constants/apiEndPoint';

export const getListPopupRequest = async (data) => {
  const result = await request({
    url: GET_LIST_POPUPS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getPopupDetailRequest = async (id) => {
  const result = await request({
    url: GET_POPUP_DETAIL,
    method: 'POST',
    data: { id },
  });
  return result?.data?.data?.data;
};

export const createUpdatePopupRequest = async (data) => {
  const result = await request({
    url: CREATE_UPDATE_POPUP,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const createPopupRequest = async (data) => {
  const result = await request({
    url: CREATE_UPDATE_POPUP,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deletePopupRequest = async (id) => {
  const result = await request({
    url: DELETE_POPUP,
    method: 'POST',
    data: { id },
  });
  return result?.data;
};

export const changePopupStatusRequest = async (data) => {
  const result = await request({
    url: POPUP_STATUS_CHANGE,
    method: 'POST',
    data,
  });
  return result?.data;
};
